import { SActionBtn, SBack, SFormAddOrEditDom, SLowcodeList, STableActions } from "shj-components";
import { useEffect, useRef, useState } from "react";
import { cloneDeep, get } from "lodash-es";
import {
  delDealkingTalkOrderHomeConf, editDealkingTalkOrderHomeConf, getHomeConfigTreePagee
} from "@/services/talkOrder.ts";
import { message, Switch, Tooltip } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import config from "./config.ts";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import AddOrEditHomeConfigDom from "./addOrEditDom";

const SecondConfig = () => {
  const listRef = useRef<any>()
  const [currentRecord, setCurrentRecord] = useState<any>();
  const [sortState, setSortState] = useState('');
  const sort = useRef<string>('');
  const [configs, setConfigs] = useState<any>(config);
  const navigate = useNavigate()
  const params = useParams()

  useEffect(() => {
    const newConfig = cloneDeep(config)
    newConfig.columns.forEach((item: any) => {
      if (item?.dataIndex === 'sortNumber') {
        item.title = (
          <div
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', justifyContent: 'space-between' }}
            onClick={sortNumberClick}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              排序
            </div>
            <Tooltip title={!sortState ? '点击升序' : sortState === 'asc' ? '点击降序' : '取消排序'} placement={'top'}>
              <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '8px' }}>
                <CaretUpOutlined style={{ fontSize: 12, color: sortState === 'asc' ? '#3D7EFF' : '#BFBFBF' }} />
                <CaretDownOutlined style={{ fontSize: 12, color: sortState === 'desc' ? '#3D7EFF' : '#BFBFBF' }} />
              </div>
            </Tooltip>
          </div>
        )
      }
    })
    setConfigs(newConfig)
  }, [])

  const sortNumberClick = () => {
    const sortArr = ['', 'asc', 'desc'];
    const index = sortArr.indexOf(sort.current);
    if (index === 2) {
      sort.current = '';
    } else {
      sort.current = sortArr[index + 1];
    }
    listRef.current.reset();
  }

  const fetchList = ({ current, pageSize, query }: any) => {
    query.pid = params?.id
    if (sort.current) {
      query.orderBys = [
        {
          columnName: 'sortNumber',
          asc: sort.current === 'asc'
        }
      ]
    } else {
      query.orderBys = [
        {
          columnName: 'lastUpdatedTime',
          asc: false
        }
      ]
    }

    return new Promise((resolve, reject) => {
      try {
        getHomeConfigTreePagee({ current, pageSize, data: query }).then((res: any) => {
          let records = get(res, 'list')
          const total = get(res, 'count')
          setSortState(sort.current)
          resolve({ records, total })
        })
      } catch (e) {
        sort.current = sortState
        reject({ success: false })
      }
    })
  };

  const onDel = (record: any) => {
    delDealkingTalkOrderHomeConf(record?.id).then((res: any) => {
      message.success('删除成功');
      listRef.current.reload()
    })
  }

  const statusChange = (value: boolean, record: any) => {
    editDealkingTalkOrderHomeConf({ ...record, status: value }).then((res: any) => {
      message.success('操作成功');
      listRef.current.reload()
    })
  }

  const extension = {
    request: { fetchList },
    events: { onAdd: () => setCurrentRecord({}) },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      operationFn(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn onClick={() => setCurrentRecord(record)}>编辑</SActionBtn>
            <SActionBtn onClick={() => {
              navigate(`/config/talkOrderConfig/advertisingList/${record?.id}/${record?.name}`)
            }}>广告列表</SActionBtn>
            <SActionBtn confirm danger title='确定删除当前菜单?' onClick={() => onDel(record)}>删除</SActionBtn>
          </STableActions>
        );
      },
      statusFn(text: boolean, record: any) {
        return <Switch checked={text} onChange={(value) => statusChange(value, record)} />
      }
    },
  };

  return (
    <SBack
        title={`菜单配置`}
        level={2}
        goPath={() => {
          navigate(-1) // 返回上一页
        }}
      >
      <SLowcodeList config={{ ...configs }} ref={listRef} {...extension} />
      <SFormAddOrEditDom
        content={<AddOrEditHomeConfigDom />}
        open={!!currentRecord}
        record={{ ...currentRecord, topPid: params?.id }}
        onClose={() => {
          setCurrentRecord(null);
        }}
        fn={() => {
          listRef?.current?.reload?.();
          setCurrentRecord(null);
        }} />
    </SBack>
  )
}

export default SecondConfig
// export default (props: any) => {
//   return (
//     <KeepAlive name={props?.location?.pathname}>
//       <SecondConfig {...props} />
//     </KeepAlive>
//   );
// };